import React from 'react';
import { Button as MuiButton, CircularProgress } from '@material-ui/core';
import { ClassNameMap } from '@material-ui/styles';
import { useStyles } from './styles';

const Button = (props: any) => {
   const { variant, color, onClick, size, disabled, loading, type, startIcon, endIcon, children } = props;
   const classes: ClassNameMap = useStyles(props);

   // Only Primary and Secondary is allowed in the color prop so we're mitigating for that
   let coloured;
   const primaryOrSecondaryColor = () => {
      if (color === 'primary' || color === 'secondary') {
         coloured = color;
      } else {
         coloured = 'inherit';
      }
   };
   primaryOrSecondaryColor();

   return (
      <MuiButton
         {...props}
         variant={variant ? variant : undefined}
         className={classes.button}
         color={coloured}
         onClick={onClick}
         size={size}
         disabled={disabled || loading}
         type={type}
         startIcon={startIcon}
         endIcon={endIcon}
      >
         {children}
         {loading && <CircularProgress size={24} className={classes.buttonProgress} />}
      </MuiButton>
   );
};

export default Button;
